export default {
  setEvents (state, events) {
    state.events = events
  },

  setEvent (state, event) {
    state.event = event
  },

  setEntries (state, entries) {
    state.entries = entries
  },

  setName (state, name) {
    state.name = name
  },

  setPlace (state, place) {
    state.place = place
  },

  setYear (state, year) {
    state.year = year
  },

  setMonth (state, month) {
    state.month = month
  },

  setDay (state, day) {
    state.day = day
  },

  setDate (state, date) {
    state.date = date
  },

  setStartHour (state, startHour) {
    state.startHour = startHour
  },

  setStartMinute (state, startMinute) {
    state.startMinute = startMinute
  },

  setFinishHour (state, finishHour) {
    state.finishHour = finishHour
  },

  setFinishMinute (state, finishMinute) {
    state.finishMinute = finishMinute
  },

  setCloseTime (state, closeTime) {
    state.closeTime = closeTime
  },

  setContent (state, content) {
    state.content = content
  },

  setTimeZone (state, timezone) {
    state.timezone = timezone
  },

  setAutoEntry (state, autoEntry) {
    state.autoEntry = autoEntry
  },
}
